import styled from 'styled-components';
import PorgressCircular from './PorgressCircular';
import ProgressBar from './ProgressBar';
import ProgressDot from './ProgressDot';

interface ProgressProps {
    shape?: ProgressShape;
    value?: number | 'indeterminate';
}

export enum ProgressShape { CIRCULAR, BAR, DOT }

export default function Progress({ shape = ProgressShape.CIRCULAR, value }: ProgressProps) {
    const progressShapes = {
        [ProgressShape.CIRCULAR]: () => <PorgressCircular value={value} />,
        [ProgressShape.BAR]: () => <ProgressBar value={value}></ProgressBar>,
        [ProgressShape.DOT]: () => <ProgressDot />,
    }

    return progressShapes[shape]();
}

const Wrapper = styled.div`
    
`